import { Component, Optional, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { NxiConfigUtil } from '@pershing/nxi-common';
import { PortalComponentService } from '../services/portal-component.service';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'modern-theme-footer',
    templateUrl: 'modern-theme-footer.component.html'
})

export class ModernThemeFooterComponent {
    community: string;
    isMobile: boolean = false;
    isTablet: boolean = false;
    isUserInNativeApp: boolean = false;
    siteSpecificPrimHasContent: boolean = true;
    isGeneric: boolean = false;
    isAdaThemeEnable: boolean = true;
    loginUrl: string = '/nxi/welcome';
    isLoggedIn: boolean = false;
    adaUrl: string = '/nxi/communications/settings/default-settings';
    constructor(private router: Router, private translationService: PershingTranslationService, private adaThemeSettingService: PortalComponentService, @Optional() @Inject('AppSettings') appSettings: any) {
        this.community = NxiConfigUtil.getCommunityName(appSettings);
        if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
            this.isMobile = true;
        }
        if (appSettings.deviceType && appSettings.deviceType === 'tablet') {
            this.isTablet = true;
        }
        if (!!appSettings && !!appSettings.isUserInNativeApp) {
            this.isUserInNativeApp = true;
        }
        if (this.community === 'netxinvestor') {
            this.isGeneric = true;
        }
        this.isLoggedIn = appSettings.isLoggedIn;

        this.checkADAThemeAccessible(appSettings);
    }
    checkADAThemeAccessible(appSettings: any) {
        if (appSettings.deviceType && (appSettings.deviceType === 'mobile' || appSettings.deviceType === 'tablet')) {
            this.isAdaThemeEnable = false;
            return;
        }
        this.isAdaThemeEnable = appSettings.ibdConfigMap?.hasOwnProperty('enableAdaLink') ? appSettings.ibdConfigMap.enableAdaLink : true;

    }
    checkContent(data: any) {
        this.siteSpecificPrimHasContent = data && !!data.articleId && data.articleId === 'site_specific_footer_primary' && data.hasContent;
    }
    handleDisclosure(): void {
        location.href = 'nxi/disclosure/brokeragedisclosure';
        // this.router.navigateByUrl('nxi/disclosure/brokeragedisclosure');
    }
    switchToAdaTheme() {
        if (this.isLoggedIn) {
            this.adaThemeSettingService.themeSettingService('ada').subscribe(data => {
                let themeSaveResponse = data;
                if (themeSaveResponse.errorCode === 0) {
                   this.navigateToLocHref(this.adaUrl+'?isModern=false&themeType=ada&communityName=' + this.community);
                }
            })
        }
        else {
            this.navigateToLocHref(this.loginUrl + '?fromLogin=true&isModern=false&themeType=ada');
        }

    }
    navigateToLocHref(url:string)
    {
        location.href = url;     
    }
}
